(function() {
    // 注册组件
    SR.component.extend('autoComplete', autoComplete);

    function autoComplete() {
        var suggestionTimer;
        var loadingTag = 'getSuggestion';
        var preKeyword;
        var hasNoResultKeyword;
        var XHR;
        var $suggestionList = SR.dom.$askSuggestion.find('.suggestion-list');
        var $input = SR.dom.$askBar.find('input');
        var $clearBtn = SR.dom.$askBar.find('.clear-btn');
        var $suggestionMask = $('<div class="suggestion-mask"></div>').css({
            display: 'none',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: SR.state.isH5 ? 48 : 0
        });

        SR.dom.$body.append($suggestionMask);

        this.getSuggestion = function(question) {
            question = question ? question.trim() : '';
            if (question.length === 0) {
                hideSuggestion();
                clearTimeout(suggestionTimer);
                return;
            }
            if (preKeyword === question) {
                return;
            }
            if (hasNoResultKeyword && question.indexOf(hasNoResultKeyword) === 0) {
                return;
            }
            if (suggestionTimer) {
                clearTimeout(suggestionTimer);
            }
            suggestionTimer = setTimeout(function() {
                fetchData(question);
                clearTimeout(suggestionTimer);
                preKeyword = question;
            }, 150);
        };

        function fetchData(question) {
            if (SR.dom.$body.hasClass(loadingTag)) {
                XHR.abort();
            }
            var urlSearch = location.search && location.search.replace('?', '');
            SR.dom.$body.addClass(loadingTag);
            XHR = $.ajax({
                method: 'POST',
                timeout: SR.data.xhrTimeout,
                url: '/suggestion',
                data: 'keyword=' + question + '&' + urlSearch
            })
                .done(function(data) {
                    var list = '';
                    if (data.ret === 0) {
                        $(data.list).each(function(index, item) {
                            list += '<li class="list-item J_suggestion">' + item + '</li>';
                        });
                        $suggestionList
                            .empty()
                            .append(list)
                            .show();
                        showSuggestion();
                    } else {
                        hideSuggestion();
                        hasNoResultKeyword = question;
                    }
                })
                .fail(function() {})
                .always(function() {
                    SR.dom.$body.removeClass(loadingTag);
                });
        }

        function showSuggestion() {
            if (!SR.dom.$askSuggestion.is('visited')) {
                SR.dom.$askSuggestion.show();
                $suggestionMask.show();
            }
        }

        function hideSuggestion() {
            $suggestionList.empty().hide();
            $suggestionMask.hide();
            preKeyword = null;
        }

        SR.dom.$body.on('click.suggestion', '.J_suggestion', function(e) {
            e.preventDefault();
            var $me = $(this);
            var question = $me.text();
            $input.val('');
            $clearBtn.hide();
            setTimeout(function() {
                hideSuggestion();
                if (SR.state.isNative && !SR.state.isDebug) {
                    upNativeComm.exec('smartRobot.setInputText', {
                        text: ''
                    });
                    SR.App.trigger('hideKeyboard');
                }
                if (question) {
                    window.ask(question);
                }
            }, 200);
        });

        $suggestionMask.on('touchstart.suggestion click.suggestion', function(e) {
            e.preventDefault();
            hideSuggestion();
        });

        SR.App.on('askFire', function() {
            hideSuggestion();
            if (XHR) {
                XHR.abort();
            }
        });

        $input.on('keyup.suggestion change.suggestion', function() {
            var $me = $(this);
            var val = $me.val().trim();
            if (val.length === 0) {
                hideSuggestion();
            }
        });
    }
})();
